import { CustomPersonCredentialApplicationStatusDefinition } from './customPersonCredentialApplicationStatusDefinition.model';
import { CredentialStatusLabelColor } from './customPersonCredentialStatusDefinition.model';
import { EntityCredentialSpecialty } from './entityCredentialSpecialty';
import { EntityCredentialPayment } from './entityCredentialPayment';
import { CredentialApplicationDefinitionType } from './CredentialApplicationDefinitionType';

export class EntityCredentialApplication {
  public credentialSpecialties: EntityCredentialSpecialty[] = [];
  constructor(
    public id: string,
    public credentialApplicationDefinitionId: string,
    public entityId: string,
    public credentialName: string,
    public entityCredentialId: string,
    public name: string,
    public credentialExpirationDate: Date,
    public credentialApplicationStartDate: Date,
    public initialStatusChangeDate: Date,
    public credentialApplicationEndDate: Date,
    public applicationNumber: string,
    public credentialDefinitionId: string,
    public assignedScenarioId: string,
    credentialSpecialties: EntityCredentialSpecialty[],
    public status: CredentialApplicationStatus,
    public credentialPayments: EntityCredentialPayment[],
    public type: CredentialApplicationDefinitionType,
    public credentialCustomApplicationStatusDefinitionModel: CustomPersonCredentialApplicationStatusDefinition
  ) {
    this.credentialSpecialties = credentialSpecialties ? credentialSpecialties : [];
  }
  static parseMany(objs: any[]): EntityCredentialApplication[] {
    return objs.map((credentialApps) => EntityCredentialApplication.parse(credentialApps));
  }
  static parse(obj: Partial<EntityCredentialApplication>): EntityCredentialApplication {
    if (obj == null) return null;
    return new EntityCredentialApplication(
      obj.id,
      obj.credentialApplicationDefinitionId,
      obj.entityId,
      obj.credentialName,
      obj.entityCredentialId,
      obj.name,
      obj.credentialExpirationDate,
      obj.credentialApplicationStartDate,
      obj.initialStatusChangeDate,
      obj.credentialApplicationEndDate,
      obj.applicationNumber,
      obj.credentialDefinitionId,
      obj.assignedScenarioId,
      obj.credentialSpecialties,
      obj.status,
      obj.credentialPayments,
      obj.type,
      obj.credentialCustomApplicationStatusDefinitionModel
    );
  }

  public getStatusColor(): CredentialStatusLabelColor {
    if (this.credentialCustomApplicationStatusDefinitionModel?.color != null) {
      return this.credentialCustomApplicationStatusDefinitionModel.color;
    }
    switch (this.status) {
      case CredentialApplicationStatus.InProgress:
      case CredentialApplicationStatus.Completed:
        return CredentialStatusLabelColor.Green;
      case CredentialApplicationStatus.Archived:
        return CredentialStatusLabelColor.Gray;
    }
  }

  public getStatusText(): string {
    if (this.credentialCustomApplicationStatusDefinitionModel?.label != null) {
      return this.credentialCustomApplicationStatusDefinitionModel.label;
    }

    switch (this.status) {
      case CredentialApplicationStatus.InProgress:
        return 'In Progress';
      case CredentialApplicationStatus.Completed:
        return 'Completed';
      case CredentialApplicationStatus.Archived:
        return 'Archived';
    }
  }
}

export enum CredentialApplicationStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Archived = 'Archived'
}
